import React, { useEffect, useState } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { useRecoilState } from 'recoil';
import { subAtom, outletAtom } from 'core/config/atoms';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import Lottie from 'lottie-react';
import { toast } from 'react-toastify';
import moment from 'moment';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import animPage from 'assets/anim/anim-pageload.json';
import ServiceBooking from 'services/serviceBooking';

export default function ComponentBookingCheckOut(props) {
    const [sub] = useRecoilState(subAtom);
    const [outlet] = useRecoilState(outletAtom);

    const [loading, setLoading] = useState(true);
    const [submit, setSubmit] = useState(false);

    const bookingService = new ServiceBooking();

    const formVSchema = Yup.object().shape({
        total: Yup.number().required('This information is required'),
        extraCharges: Yup.number().required('This information is required'),
        discount: Yup.number().required('This information is required'),
        grand: Yup.number().required('This information is required'),
        paid: Yup.number().required('This information is required'),
        payment: Yup.number().required('This information is required'),
        paymentMode: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            total: 0,
            extraCharges: 0,
            discount: 0,
            tax: 0,
            grand: 0,
            paid: 0,
            pending: 0,
            payment: 0,
            paymentMode: '',
        },
        enableReinitialze: true,
        validationSchema: formVSchema,
        onSubmit: values => {
            if ((values.paid + values.payment) === props.book.finaltotal) {
                setSubmit(true);
                var body = {
                    "bookid": props.book._id,
                    "outlet": outlet.outletid.outletid,
                    "outletid": outlet.outletid.id,
                    "payment": values.payment,
                    "paymentMode": values.paymentMode,
                    "data": {
                        "total": values.total,
                        "extraCharge": values.extraCharges,
                        "discount": values.discount,
                        "tax": values.tax,
                        "finaltotal": values.grand,
                        "paid": values.paid + values.payment,
                        "paymentStatus": getPaymentSts(values),
                        "status": "complete",
                    },
                };
                bookingService.checkoutBooking(body, '').then((res) => {
                    if (res.status) {
                        resetForm();
                        props.onClose();
                        toast.success('Booking check out done!.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                    setSubmit(false);
                });
            } else {
                toast.error('Pleae collect all the pending payment.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        }
    });

    const getPaymentSts = (val) => {
        var newPayment = values.paid + values.payment;
        if (val.grand >= newPayment) {
            return "paid";
        }
        if (val.grand > newPayment) {
            return "partial";
        }
        return "pending";
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            const pned = props.book.finaltotal - props.book.paid;
            setValues({ ...values, total: props.book.total, extraCharges: props.book.extraCharge, discount: props.book.discount, tax: props.book.tax, grand: props.book.finaltotal, paid: props.book.paid, pending: pned });
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>Booking Check - Out</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                resetForm();
                                props.onClose();
                            }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <hr className='my-2' />
                        {
                            loading && <div className='flex items-center justify-center w-full h-full'>
                                <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                            </div>
                        }
                        {
                            !loading && <form className='mt-4 grid grid-cols-12 gap-4' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>

                                <div className="col-span-12 font-medium">
                                    <p>Booking Details</p>
                                    <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                                </div>

                                <div className="intro-y col-span-6 shadow rounded-md overflow-hidden">
                                    <div className="bg-white sm:p-4 rounded-lg flex items-start">
                                        <div className="flex items-center space-x-2 mr-4">
                                            <div className='min-w-[100px] flex flex-col items-center border bg-gray-50 border-prime p-2 rounded-md space-y-3'>
                                                <p className='text-sm font-medium text-gray-600'>FROM</p>
                                                <p className='text-4xl font-medium'>{moment(props.book.checkIn).format('DD')}</p>
                                                <p className='text-sm font-medium text-gray-600 uppercase'>{moment(props.book.checkIn).format('ddd')}</p>
                                            </div>
                                            <div>-</div>
                                            <div className='min-w-[100px] flex flex-col items-center border bg-gray-50 border-prime p-2 rounded-md space-y-3'>
                                                <p className='text-sm font-medium text-gray-600'>TO</p>
                                                <p className='text-4xl font-medium'>{moment(props.book.checkOut).format('DD')}</p>
                                                <p className='text-sm font-medium text-gray-600 uppercase'>{moment(props.book.checkOut).format('ddd')}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-start">
                                            <p className=''>Booking ID:&nbsp;<span className='font-medium'>{props.book.bookID}</span></p>
                                            <p className='text-sm'>Name:&nbsp;<span className='font-medium'>{props.book.bookName}</span></p>
                                            <div className=''>
                                                <p className='text-xs text-gray-600 font-medium'>Email:&nbsp;<span>{props.book.bookEmail}</span></p>
                                                <p className='text-xs text-gray-600 font-medium'>Phone:&nbsp;<span>{props.book.bookPhone}</span></p>
                                            </div>
                                            <div className='flex-grow'></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-12 font-medium">
                                    <p>Payment information</p>
                                    <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Booking Total (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="total" value={values.total} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.total && touched.total) && <p className='text-xs text-red-400 mt-1'>{errors.total}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Extra Charges (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="extraCharges" value={values.extraCharges} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.extraCharges && touched.extraCharges) && <p className='text-xs text-red-400 mt-1'>{errors.extraCharges}</p>}
                                </div>

                                {
                                    sub.features.isTax && <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Tax (%)<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="tax" value={values.tax} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                        {(errors.tax && touched.tax) && <p className='text-xs text-red-400 mt-1'>{errors.tax}</p>}
                                    </div>
                                }

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Discount (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="discount" value={values.discount} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.discount && touched.discount) && <p className='text-xs text-red-400 mt-1'>{errors.discount}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Grand Total (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="grand" value={values.grand} autoComplete='off' readOnly className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. x" onChange={handleChange} />
                                    {(errors.grand && touched.grand) && <p className='text-xs text-red-400 mt-1'>{errors.grand}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Advance Payment (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="paid" value={values.paid} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.paid && touched.paid) && <p className='text-xs text-red-400 mt-1'>{errors.paid}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Pending Balance (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="pending" value={values.pending} readOnly autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.pending && touched.pending) && <p className='text-xs text-red-400 mt-1'>{errors.pending}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Payment (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="payment" value={values.payment} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.payment && touched.payment) && <p className='text-xs text-red-400 mt-1'>{errors.payment}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Payment Mode<sup className="text-red-600">*</sup></label>
                                    <select id="paymentMode" value={values.paymentMode} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" onChange={handleChange}>
                                        <option value="">Select Payment Mode</option>
                                        <option value="UPI">UPI</option>
                                        <option value="CASH">CASH</option>
                                        <option value="Online">Online</option>
                                        <option value="Regular">Regular</option>
                                        <option value="GoMMT">GoMMT</option>
                                        <option value="OYO Paid">OYO Paid</option>
                                        <option value="Booking.com">Booking.com</option>
                                        <option value="Agoda">Agoda</option>
                                        <option value="Website">Website</option>
                                    </select>
                                    {(errors.paymentMode && touched.paymentMode) && <p className='text-xs text-red-400 mt-1'>{errors.paymentMode}</p>}
                                </div>

                                <div className="col-span-12 intro-y px-2 py-3 bg-gray-100 text-left">
                                    <button type="submit" disabled={submit} className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-prime hover:bg-primeLight">
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                        {!submit && "CHECK OUT"}
                                    </button>
                                </div>
                            </form >
                        }
                    </div>
                </ScrollArea >
            </div>
        </div>
    )
}
